






































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { PolicyDataInfo } from '../../utils';
console.log('模板2')

@Component
export default class PrivacyPolicyZhFirst extends Vue {
    @Prop({ type: Object, required: true}) private formData!: PolicyDataInfo
}
